(function () {
  const roots = Array.from(document.querySelectorAll(".js-cta-marquee"));
  if (!roots.length) return;

  const gsap = window.gsap;
  if (!gsap) return;

  const prefersReduced =
    window.matchMedia &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  if (window.ScrollTrigger) gsap.registerPlugin(window.ScrollTrigger);

  const debounce =
    gsap.utils && typeof gsap.utils.debounce === "function"
      ? gsap.utils.debounce
      : (fn, wait = 150) => {
          let t;
          return (...args) => {
            window.clearTimeout(t);
            t = window.setTimeout(() => fn(...args), wait);
          };
        };

  roots.forEach((root) => {
    if (root.dataset.init === "1") return;
    root.dataset.init = "1";

    const frame = root.querySelector(".cta-marquee__frame");
    const overlay = root.querySelector(".cta-marquee__overlay");
    const below = root.querySelector(".cta-marquee__below");
    const track = root.querySelector(".cta-marquee__marquee-track");

    if (!prefersReduced) {
      const revealTargets = [frame, overlay, below].filter(Boolean);
      if (revealTargets.length) {
        gsap.set(revealTargets, { opacity: 0, y: 18 });
        gsap.to(revealTargets, {
          opacity: 1,
          y: 0,
          duration: 0.9,
          ease: "power2.out",
          stagger: 0.08,
          scrollTrigger: window.ScrollTrigger
            ? { trigger: root, start: "top 85%", once: true }
            : undefined,
        });
      }
    }

    if (!track || prefersReduced) return;

    const speed = 90; // px/sec

    const run = () => {
      gsap.killTweensOf(track);
      gsap.set(track, { x: 0 });

      const half = track.scrollWidth / 2;
      if (!half) return;

      gsap.to(track, {
        x: -half,
        duration: half / speed,
        ease: "none",
        repeat: -1,
      });
    };

    run();

    const onResize = debounce(run, 150);
    window.addEventListener("resize", onResize);
  });
})();
